import React , {useEffect} from "react";
import { useNavigate } from "react-router-dom";
import "./AssessmentPage.css";
import {
  Brain,
  BookOpen,
  FileBarChart2,
  Trophy,
  Bell,
  ArrowRight,
  LogOut
} from "lucide-react";


const AssessmentPage = () => {
  useEffect(() => {
  
      const websiteNavbar =
        document.querySelector(".navbar");
  
      if (websiteNavbar) {
  
        websiteNavbar.style.display = "none";
  
      }
  
      return () => {
  
        if (websiteNavbar) {
  
          websiteNavbar.style.display = "";
  
        }
  
      };
  
    }, []);

  const navigate = useNavigate();

  /* ==========================
          ASSESSMENTS
  ========================== */
  const logout = () => {

  // Clear user data
  localStorage.removeItem("email");
  

  // Or clear everything
  // localStorage.clear();

  // Navigate to Login page
  navigate("/");

};
  const assessments = [

    {
      id: 1,
      title: "Visual Acuity",
      description:
        "Measure the sharpness and clarity of your vision at varied distances and lighting conditions.",
      icon: "👁️",
      route: "/visual-acuity"
    },

    {
      id: 2,
      title: "Color Vision Test",
      description:
        "Evaluate your ability to distinguish between subtle hue variations and color contrast levels.",
      icon: "🎨",
      route: "/color-vision"
    },

    {
      id: 3,
      title: "Contrast Sensitivity",
      description:
        "Test your capacity to detect foreground objects against complex, low-contrast backgrounds.",
      icon: "◐",
      route: "/contrast"
    },

    {
      id: 4,
      title: "Reaction Game",
      description:
        "A high-speed interactive assessment to measure visual reaction time and response accuracy.",
      icon: "🎯",
      route: "/reactiongame"
    },

    {
      id: 5,
      title: "Reaction Speed (Complex)",
      description:
        "Evaluate decision-making speed while processing multiple competing visual stimuli.",
      icon: "⚡",
      route: "/complex-reaction"
    },

    {
      id: 6,
      title: "Short-Term Visual Memory",
      description:
        "Assess your ability to retain and recall visual patterns over short intervals.",
      icon: "🧠",
      route: "/short-term-memory"
    },

    {
      id: 7,
      title: "Working Memory Test",
      description:
        "Evaluate your ability to hold and manipulate information in your mind.",
      icon: "🧩",
      route: "/working-memory"
    },

    {
      id: 8,
      title: "Search Span Test",
      description:
        "Measure your visual scanning efficiency and ability to locate targets.",
      icon: "🔍",
      route: "/search-span"
    },

    {
      id: 9,
      title: "Anticipation Test",
      description:
        "Assess your ability to predict and respond to upcoming visual events.",
      icon: "🔭",
      route: "/anticipation"
    }

  ];

  /* ==========================
        START TEST
  ========================== */

  const startAssessment = (route) => {

    navigate(route);

  };

  return (

<div className="assessment-page">

  {/* ==========================
          NAVBAR
  ========================== */}

  <header className="assessment-navbar">

    <div
      className="assessment-logo"
      onClick={() => navigate("/member-dashboard")}
    >

      <img
        src="/logo.png"
        alt="Forge Your Peak"
      />

      <span>

        Forge Your Peak

      </span>

    </div>

    <div className="assessment-nav-right">

  <button
    className="back-btn"
    onClick={() => navigate("/member-dashboard")}
  >
    ← Back to Dashboard
  </button>

  
<div  className="profile-section"
  >
 <button
  className="logout-navbar-btn"
  onClick={logout}
>
  <LogOut size={18} />
  Logout
</button>
</div>

</div>

  </header>

  {/* ==========================
          HEADER
  ========================== */}

  <section className="assessment-header">

    <div className="assessment-header-icon">

      🧠

    </div>

    <div>

      <h1>

        Assessments

      </h1>

      <p>

        Choose an assessment to begin your performance evaluation.

      </p>

      <p>

        Each module is designed to calibrate your cognitive and sensory baselines.

      </p>

    </div>

  </section>

  {/* ==========================
        ASSESSMENT GRID
  ========================== */}

  <section className="assessment-grid">
          {assessments.map((assessment) => (

        <div
          className="assessment-card"
          key={assessment.id}
        >

          <div className="assessment-icon">

            {assessment.icon}

          </div>

          <div className="assessment-content">

            <h2>

              {assessment.title}

            </h2>

            <p>

              {assessment.description}

            </p>

          </div>

          <button
            className="assessment-btn"
            onClick={() =>
              startAssessment(
                assessment.route
              )
            }
          >

            Start Test

            <span>

              →

            </span>

          </button>

        </div>

      ))}

  </section>

</div>

);

};

export default AssessmentPage;